import { render, staticRenderFns } from "./DomainsList.vue?vue&type=template&id=2c7d0aed&"
import script from "./DomainsList.vue?vue&type=script&lang=js&"
export * from "./DomainsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7d0aed')) {
      api.createRecord('2c7d0aed', component.options)
    } else {
      api.reload('2c7d0aed', component.options)
    }
    module.hot.accept("./DomainsList.vue?vue&type=template&id=2c7d0aed&", function () {
      api.rerender('2c7d0aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainsList.vue"
export default component.exports